export const focusedNewConversationsRollupText = "gXa";
export const otherNewConversationsRollupText = "hXa";
export const focusedNewMessagesRollupText = "iXa";
export const otherNewMessagesRollupText = "jXa";
export default {focusedNewConversationsRollupText,otherNewConversationsRollupText,focusedNewMessagesRollupText,otherNewMessagesRollupText};